import { render, staticRenderFns } from "./searchManifesto.vue?vue&type=template&id=500366f7&"
import script from "./searchManifesto.vue?vue&type=script&lang=js&"
export * from "./searchManifesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports